// extracted by mini-css-extract-plugin
var _1 = "auth-column__Knsx7";
var _2 = "container__bxXxV";
var _3 = "content__kbBaZ";
var _4 = "form__cJm3D";
var _5 = "logo__eiDup";
var _6 = "logo-container__xpQfr";
var _7 = "portrait-pattern__jamQ_";
var _8 = "shell__OqWPM";
var _9 = "st-logo__oGB0h";
export { _1 as "authColumn", _2 as "container", _3 as "content", _4 as "form", _5 as "logo", _6 as "logoContainer", _7 as "portraitPattern", _8 as "shell", _9 as "stLogo" }
